module.exports = __webpack_public_path__ + "static/media/afinando_plus_tint_purple.a2582df4.svg";